import * as httpHelper from "../../utils/http-helper";

function buscarDocumentos() {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(headers, "Documentos/Listar");
}

const documentosService = { buscarDocumentos };

export default documentosService;
